module.exports = __webpack_public_path__ + "static/media/40x40-0.7eb26db6.png";